export function getUmbracoMediaUrl(url?: string, onlyMedia?: boolean) {
  // Use CDN_URL if defined, otherwise fall back to GRAPHQL_URL
  const MEDIA_BASE_URL = process.env.CDN_URL || process.env.GRAPHQL_URL?.replace("/graphql", "")

  if (!url) {
    return ""
  }
  // Pass through data URIs and absolute non-media URLs
  if (url.startsWith("data:")) {
    return url
  }
  if (onlyMedia) {
    return MEDIA_BASE_URL + "/" + url
  }

  // Handle relative paths starting with /media/ or media/
  if (url.startsWith("/media/")) {
    return MEDIA_BASE_URL + url
  }
  if (url.startsWith("media/")) {
    return MEDIA_BASE_URL + "/" + url
  }

  // Replace url before /media/ with media base url (for full URLs)
  const updatedUrl = url?.replace(/(https?:\/\/[^\/]+\/media\/)/, MEDIA_BASE_URL + "/media/")

  return updatedUrl
}
